import CreateAmendmentViewModel from 'jobs/views/JobRoot/Job/AmendmentsCard/CreateAmendmentDialog/CreateAmendmentViewModel'
import { AlertFactory, AlertState } from 'alerts/Alert'
import { SelectPaymentMethodDelegate } from 'billing/payment-methods/PaymentMethodsRootViewModel'
import DocumentAccessStore from 'documents/DocumentAccessStore'
import DocumentStore from 'documents/DocumentStore'
import DocumentVersionStore from 'documents/DocumentVersionStore'
import { DocumentPickerViewModel } from 'documents/views/DocumentPicker/DocumentPickerViewModel'
import { ViewDocumentDetailsDelegate } from 'documents/views/DocumentRoot/DocumentDetailsRootViewModel'
import JobDocumentsViewModel from 'jobs/views/JobRoot/Job/JobDocumentsViewModel'
import { FindMembers } from 'iam/MemberStore'
import Member from 'iam/models/Member'
import Team from 'iam/models/Team'
import { PermissionSubject } from 'iam/PermissionSubject'
import { GetCurrentMember } from 'iam/SessionStore'
import {
  FetchTeamMember,
  FindTeamMembers,
  FindUserTeamMembersByUserPublicId,
} from 'iam/TeamMemberStore'
import Job, { Collaborator } from 'jobs/Job'
import { JobDocumentsLinkingAdapter } from 'jobs/JobDocumentsLinkingAdapter'
import JobStore, {
  ScopeChangeInventoryParams,
  ScopeChangeParams,
} from 'jobs/JobStore'
import MilestoneStore from 'jobs/MilestoneStore'
import QuestionStore, { QuestionsQuerySession } from 'jobs/QuestionStore'
import CopyJobViewModel from 'jobs/views/CopyJobDialog/CopyJobViewModel'
import once from 'lodash/once'
import { ConversationViewModelFactory } from 'messaging/components/ConversationView/ConversationViewModel'
import Conversation from 'messaging/models/Conversation'
import { action, computed, makeObservable, observable } from 'mobx'
import { task } from 'mobx-task'
import { createTransformer } from 'mobx-utils'
import DesktopNotificationStore from 'notifications/DesktopNotificationStore'
import { asapScheduler, merge, Subject, Subscription } from 'rxjs'
import {
  concatMap,
  filter,
  observeOn,
  share,
  switchMap,
  tap,
} from 'rxjs/operators'
import { Shortcuts } from 'shortcuts/Shortcuts'
import { Id, Router } from 'types/definitions'
import QuestionListViewModel from '../../../questions/QuestionListViewModel'
import RenameJobViewModel from '../../RenameJobDialog/RenameJobViewModel'
import { CollaboratorViewModel } from './CollaboratorsCard/CollaboratorViewModel'
import CorrectionsViewModel from './CorrectionsDialog/CorrectionsViewModel'
import DetailsViewModel from './DetailsView/DetailsViewModel'
import ForfeitViewModel from './ForfeitDialog/ForfeitViewModel'
import { JobDocumentsAdapter } from '../../../JobDocumentsViewModelAdapter'
import MilestonesViewModel from './MilestonesCard/Milestones/MilestonesViewModel'
import { MessageBankDialogViewModelFactory } from 'messaging/message-bank/MessageBankDialog/MessageBankDialogViewModel'
import SureprepStore from 'sureprep/SureprepStore'
import CloseJobAsAdminDialogViewModel from 'jobs/views/CloseJobDialog/CloseJobAsAdminDialog/CloseJobAsAdminViewModel'
import { CloseJobDialogAdapter } from 'jobs/views/CloseJobDialog/CloseJobDialogAdapter'
import BillingStore from 'billing/BillingStore'
import TransferJobViewModel from './TransferJobDialog/TransferJobViewModel'
import RemoveClientTeamViewModel from './RemoveClientTeamDialog/RemoveClientTeamViewModel'
import RemoveCollaboratorsAsAdminViewModel from './RemoveCollaboratorsAsAdminDialog/RemoveCollaboratorsAsAdminViewModel'
import AddCollaboratorsAsAdminViewModel from './AddCollaboratorsAsAdminDialog/AddCollaboratorsAsAdminViewModel'
import ApplyCouponAsAdminViewModel from './ApplyCouponAsAdminDialog/ApplyCouponAsAdminViewModel'
import RemoveCouponAsAdminViewModel from './RemoveCouponAsAdminDialog/RemoveCouponAsAdminViewModel'
import { differenceInDays, toDate } from 'date-fns'
import ReopenJobAsAdminViewModel from './ReopenJobAsAdminDialog/ReopenJobAsAdminViewModel'
import { SplitPayoutDialogViewModel } from './SplitPayoutDialog/SplitPayoutDialogViewModel'
import RequestScopeChangesViewModel from './RequestScopeChangesDialog/RequestScopeChangesViewModel'
import ViewScopeChangesViewModel from './ViewJobScopeChangeRequestDialog/ViewJobScopeChangeRequestViewModel'
import JobScopeChangeRequest from 'jobs/JobScopeChange'
import { getFeatureToggleClient } from '../../../../infra/featureToggles'
import JobProgressionStore from 'jobs/progression/JobProgressionStore'
import JobProgressionViewModel from './JobProgressionCard/JobProgressionViewModel'
import { EnsureTermsAccepted } from 'iam/views/TermsModal/TermsModalViewModel'
import { isNotNil } from 'utils/object-util'
import ApproveDraftInReviewDialogViewModel from './ApproveDraftInReviewDialog/ApproveDraftInReviewDialogViewModel'
import RejectDraftInReviewDialogViewModel from './RejectDraftInReviewDialog/RejectDraftInReviewDialogViewModel'
import JobConversationViewModelAdapter from 'messaging/components/ConversationView/JobConversationViewModelAdapter'
import ConversationStore from 'messaging/ConversationStore'
import { ConsultationIncompleteReason } from 'jobs/consultations/Consultation'
import { DeleteJobDialogViewModel } from './DeleteJobDialog/DeleteJobDialogViewModel'
import ProviderStore from 'jobs/ProviderStore'
import { JobTicketStore } from 'jobs/tickets/JobTicketStore'
import { JobTicketsViewModel } from './JobTicketsViewModel'
import CouponStore from 'billing/CouponStore'
import { AddManualInvoiceDialogViewModel } from './AddManualInvoiceDialog/AddManualInvoiceDialogViewModel'
import { UpdateDeadlineDialogViewModel } from './UpdateDeadlineDialog/UpdateDeadlineDialogViewModel'
import InventoryStore from 'admin/InventoryStore'
import SubmitJobDialogViewModel from './SubmitJobDialog/SubmitJobDialogViewModel'
import SubmitJobDialogAdapter from './SubmitJobDialog/SubmitJobDialogAdapter'
import { NotifyProsOfOpenJobDialogViewModel } from './NotifyProsOfOpenJobDialog/NotifyProsOfOpenJobViewModel'
import { JobInsightsViewModel } from './JobInsightsCard/JobInsightsViewModel'
import { InsightStore } from 'jobs/insights/InsightStore'
import { timeago } from 'utils/date-util'
import { ChargeOrRefundDialogViewModel } from './ChargeOrRefundDialog/ChargeOrRefundDialogViewModel'
import TeamStore from 'iam/TeamStore'
import InfoGatheringStore from '../../../InfoGatheringStore'
import InfoGatheringCardViewModel from './InfoGatheringCard/InfoGatheringCardViewModel'
import { ProviderActivePtinStatusDto } from '../../../../iam/models/ProviderActivePtinStatusDto'
import { GetUserData } from '../../../../iam/UserDataStore'
import { UserDataType } from '../../../../iam/models/UserDataType'
import UpdateJobScopeViewModel from './UpdateJobScopeDialog/UpdateJobScopeViewModel'
import ServiceItemListViewModel from './ServiceItemListDialog/ServiceItemListViewModel'
import AddClientsAsTeamMemberViewModel from './AddClientsAsTeamMemberDialog/AddClientsAsTeamMemberViewModel'
import RemoveClientsAsNonAdminViewModel from './RemoveClientsAsNonAdminDialog/RemoveClientsAsNonAdminViewModel'
import CreateJobDialogViewModel from 'jobs/creation/views/JobCreationDialog/JobCreationDialogViewModel'
import JobRatingsStore from '../../../ratings/JobRatingStore'
import RatingsViewModel from '../../../ratings/RatingsViewModel'
import { UpdateProgressionStepDialogVM } from './UpdateProgressionStepDialog/UpdateProgressionStepDialogVM'
import BookkeepingProgressionViewModel from './BookkeepingProgressionCard/BookkeepingProgressionViewModel'
import BookkeepingProgressionStore from 'jobs/bookkeeping/BookkeepingProgressionStore'
import isBookkeepingEnabled from 'jobs/bookkeeping/BookkeepingFeatureToggle'
import BookkeepingCorrectCycleDialogViewModel from './BookkeepingCorrectCycleDialog/BookkeepingCorrectCycleDialogViewModel'
import BookkeepingSelectCycleViewModel from './BookkeepingSelectCycleDialog/BookkeepingSelectCycleDialogViewModel'
import ConsultationPendingBookingModalViewModel, {
  ConsultationPendingBookingResult,
} from './ConsultationPendingBookingModal/ConsultationPendingBookingModal'
import ConsultationStore from '../../../consultations/ConsultationStore'
import link from '../../../../infra/link'
import { IsFirmAdminInWorkspace } from '../JobRootViewModel'
import { SupportingItemsPorts } from 'admin/ports'
import { DocumentRequestDialogViewModel } from './DocumentRequestDialog/DocumentRequestDialogViewModel'
import DocumentRequestStore from 'jobs/document-requests/DocumentRequestStore'
import RoomViewModel from './RoomCard/RoomViewModel'
import RoomStore from '../../../../messaging/rooms/RoomStore'
import {
  AddToCalendarDelegate,
  ExternalUrlDelegate,
} from 'shell/platform/types'
import { ConsultationStatus } from '../../../consultations/Consultation'
import NotesViewModel from './CapturedInformationCard/NotesViewModel'
import EditPersonalProfileDialogViewModel from './CapturedInformationCard/EditPersonalProfileDialog/EditPersonalProfileDialogViewModel'
import EditBusinessProfileDialogViewModel from './CapturedInformationCard/EditBusinessProfileDialog/EditBusinessProfileDialogViewModel'
import EditRefundDialogViewModel from './CapturedInformationCard/EditRefundDialog/EditRefundDialogViewModel'
import BusinessInfoViewModel from 'jobs/info-gathering/business-info/BusinessInfoViewModel'
import TaxRefundMethodViewModel from 'jobs/info-gathering/tax-refund-method/TaxRefundMethodViewModel'
import BusinessProfileStore from 'jobs/info-gathering/business-info/BusinessProfileStore'
import IndividualProfileStore from 'jobs/info-gathering/individual-info/IndividualProfileStore'
import PersonalProfileViewModel from 'jobs/info-gathering/individual-info/PersonalProfile/PersonalProfileViewModel'
import SpousalProfileViewModel from 'jobs/info-gathering/individual-info/SpousalProfile/SpousalProfileViewModel'
import DependentProfileViewModel from 'jobs/info-gathering/individual-info/DependentProfile/DependentProfileViewModel'
import TaxRefundMethodStore from 'jobs/info-gathering/tax-refund-method/TaxRefundMethodStore'
import AvailableJobProgressionFlowsStore from 'jobs/progression/AvailableJobProgressionFlows/AvailableJobProgressionFlowsStore'
import IncompleteConsultationCompletionDialogViewModel from './IncompleteConsultationCompletionDialog/IncompleteConsultationCompletionDialogViewModel'
import { DocumentManualVerificationViewModel } from 'jobs/views/JobRoot/Job/DocumentManualVerificationModal/DocumentManualVerificationViewModel'
import TxfJobStore from 'jobs/TxfJobStore'
import TxfJobViewModel from './TxfJobCard/TxfJobViewModel'

/**
 * Manages the state of the Job view.
 */
export default class JobViewModel {
  /**
   * Manages an Rx subscription while the VM is active.
   */
  private subscription = new Subscription()

  /**
   * Used to trigger the Events section in the sidebar.
   * Since the sections are not fully controlled (nor do we want them to be),
   * we need a way to signal to the UI to reveal the events section in the Details
   * sidebar.
   *
   * @private
   */
  private revealEventsSubject = new Subject()

  /**
   * Used for the Documents Question type.
   */
  private jobDocumentsLinkingAdapter = new JobDocumentsLinkingAdapter(
    this.job,
    this.documentStore,
    this.documentVersionStore,
    this.documentAccessStore,
    this.getCurrentMember,
  )

  /**
   * Creates the Questions VM configured for this particular job..
   */
  private createQuestionListViewModel = () =>
    new QuestionListViewModel({
      getAsOfDate: () => this.job.dateCreated,
      documentRequestsAdapterFactory: () =>
        this.jobDocumentsLinkingAdapter.documentRequestsAdapter,
    })

  /**
   * Emits when the Events tab should be revealed.
   */
  revealEvents$ = this.revealEventsSubject.pipe(
    tap(() => this.setTab(Tab.Details)),
    observeOn(asapScheduler),
    share(),
  )

  /**
   * Transform a Collaborator to a Collaborator VM.
   */
  createCollaboratorVM = createTransformer<Collaborator, CollaboratorViewModel>(
    (collaborator) => {
      const vm = new CollaboratorViewModel(collaborator, this.getCurrentMember)
      vm.activate()
      return vm
    },
    (vm) => vm && vm.deactivate(),
  )

  /**
   * Dialog for renaming.
   */
  renameVM = new RenameJobViewModel(
    this.job,
    this.jobStore.rename.bind(this.jobStore),
  )

  /**
   * Dialog for creating an amendment.
   */
  createAmendmentVM = new CreateAmendmentViewModel(
    this.job,
    this.jobStore,
    this.newAlert,
  )

  /**
   * Dialog for approving DraftInReview job progression
   */
  approveDraftInReviewDialogVM = new ApproveDraftInReviewDialogViewModel(
    this.progressionStore,
    this.job,
  )

  /**
   * Dialog for rejecting DraftInReview job progression
   */
  rejectDraftInReviewDialogVM = new RejectDraftInReviewDialogViewModel(
    this.progressionStore,
    this.job,
  )

  /**
   * Dialog for forfeiting.
   */
  forfeitVM = new ForfeitViewModel(this.job, this.jobStore, this.router)

  /**
   * Dialog for the Corrections editor.
   */
  correctionsVM = new CorrectionsViewModel(
    this.job,
    this.createQuestionsQuerySession,
    this.questionStore,
    this.jobStore,
    this.createQuestionListViewModel,
    this.newAlert,
  )

  jobProgressionVM = new JobProgressionViewModel(
    this.progressionStore,
    this.availableJobProgressionFlowsStore,
    () => this.requestCloseAsCollaborator(),
    () => this.documentsVM.createDocumentCreationModalViewModel([]),
    () => this.documentsVM.documents,
    () => this.documentRequestDialogVM.promptForDocumentRequest(),
    this.job,
    this.newAlert,
  )

  /**
   * Dialog for viewing ratings.
   */
  ratingsVM = new RatingsViewModel(
    this.job,
    this.jobRatingStore,
    this.newAlert,
    this.jobProgressionVM,
  )

  /**
   * Dialog for transferring job.
   */
  transferJobVM = new TransferJobViewModel(
    this.findMembers,
    this.findTeamMembersByUserPublicId,
    this.jobStore,
    this.providerStore,
    this.newAlert,
    this.ratingsVM,
  )

  /**
   * Dialog for removing the client team from a job.
   */
  removeClientTeamVM = new RemoveClientTeamViewModel(
    this.job,
    this.jobStore,
    this.newAlert,
  )

  /**
   * Dialog for removing collaborators as Admin.
   */
  removeCollaboratorsAsAdminVM = new RemoveCollaboratorsAsAdminViewModel(
    this.job,
    this.jobStore,
    this.newAlert,
    this.getCurrentMember,
  )

  /**
   * Dialog for adding collaborators as Admin.
   */
  addCollaboratorsAsAdminVM = new AddCollaboratorsAsAdminViewModel(
    this.job,
    this.jobStore,
    this.findMembers,
    this.findTeamMembers,
    this.providerStore,
    this.newAlert,
    this.getCurrentMember,
  )

  /**
   * Dialog for adding clients as a team member.
   */
  addClientsAsTeamMemberVM = new AddClientsAsTeamMemberViewModel(
    this.job,
    this.jobStore,
    this.findTeamMembers,
    this.newAlert,
  )

  /**
   * Dialog for removing clients as a non-admin.
   */
  removeClientsAsNonAdminVM = new RemoveClientsAsNonAdminViewModel(
    this.job,
    this.jobStore,
    this.newAlert,
  )

  /**
   * Dialog for applying coupons as Admin.
   */
  applyCouponAsAdminVM = new ApplyCouponAsAdminViewModel(
    this.job,
    this.jobStore,
    this.couponStore,
    this.newAlert,
  )

  /**
   * Dialog for removing coupons as Admin.
   */
  removeCouponAsAdminVM = new RemoveCouponAsAdminViewModel(
    this.job,
    this.jobStore,
    this.couponStore,
    this.newAlert,
  )

  /**
   * Dialog for reopening a job as Admin.
   */
  reopenJobAsAdminVM = new ReopenJobAsAdminViewModel(
    this.job,
    this.jobStore,
    this.newAlert,
  )

  /**
   * Conversation view model.
   */
  conversationVM = this.createConversationViewModel(
    this.job.conversation ?? Conversation.none,
    this.job.currentUserCollaborator?.team ?? Team.none,
    JobConversationViewModelAdapter(
      this.newAlert,
      this.conversationStore,
      this,
    ),
    this.job,
  )

  roomVM = new RoomViewModel(
    this.job,
    this.roomStore,
    this.getCurrentMember,
    this.getExternalUrlDelegate,
  )

  consultationPendingBookingModalVM =
    new ConsultationPendingBookingModalViewModel()

  /**
   * View model for the Documents tab.
   */
  documentsVM = new JobDocumentsViewModel(
    this.job,
    this.newAlert,
    this.viewDocumentDetails,
    this.jobDocumentsAdapter,
    this.getCurrentMember,
    () => this.checklist,
    this.documentVersionStore.clientDataManualVerificationRequired$,
    this.documentManualVerificationVM,
  )

  infoGatheringCardVM = new InfoGatheringCardViewModel(
    this.job,
    this.newAlert,
    () => this.checklist,
    this.jobWorkspaceMember,
    this.job.currentUserCollaborator,
    this.jobStore,
  )

  notesVM = new NotesViewModel(
    this.job,
    this.infoGatheringStore,
    () => this.checklist,
    this.isFirmAdminInWorkspace,
    this.newAlert,
  )

  /**
   * View model for personal profile tab.
   */
  personalProfileVM = new PersonalProfileViewModel(
    this.job,
    this.infoGatheringStore,
    this.individualProfileStore,
    () => this.checklist,
  )

  /**
   * View model for spousal profile tab.
   */
  spousalProfileVM = new SpousalProfileViewModel(
    this.job,
    this.infoGatheringStore,
    this.individualProfileStore,
    () => this.checklist,
  )

  dependentProfileVM = new DependentProfileViewModel(
    this.job,
    this.infoGatheringStore,
    this.individualProfileStore,
    () => this.checklist,
  )

  editPersonalProfileDialogVM = new EditPersonalProfileDialogViewModel(
    this.job,
    this.personalProfileVM,
    this.spousalProfileVM,
    this.dependentProfileVM,
    this.individualProfileStore,
    this.infoGatheringStore,
    this.newAlert,
  )

  /**
   * View model for business tab.
   */
  businessInfoVM = new BusinessInfoViewModel(
    this.job,
    this.infoGatheringStore,
    this.businessProfileStore,
    () => this.checklist,
  )

  editBusinessProfileDialogVM = new EditBusinessProfileDialogViewModel(
    this.job,
    this.businessInfoVM,
    this.businessProfileStore,
    this.infoGatheringStore,
    this.newAlert,
  )

  /**
   * View model for refund tab.
   */
  taxRefundMethodVM = new TaxRefundMethodViewModel(
    this.job,
    this.infoGatheringStore,
    this.taxRefundMethodStore,
    () => this.checklist,
  )

  editRefundDialogVM = new EditRefundDialogViewModel(
    this.job,
    this.taxRefundMethodVM,
    this.taxRefundMethodStore,
    this.infoGatheringStore,
    this.newAlert,
  )

  /**
   * Used for the Document Picker that links documents to the job.
   */
  documentLinkingPickerVM = new DocumentPickerViewModel(
    this.jobDocumentsLinkingAdapter.documentPickerAdapter,
  )

  /**
   * Milestones view model.
   */
  milestonesVM = new MilestonesViewModel(this, this.milestoneStore)

  /**
   * Details view model.
   */
  detailsVM = new DetailsViewModel(
    this.job,
    this.jobStore,
    this.createQuestionsQuerySession(),
    this.createQuestionListViewModel,
    () => this.useEditDraftJobForFirmAdmin,
  )

  /**
   * Job tickets view model.
   */
  jobTicketsVM = new JobTicketsViewModel(this.job, this.jobTicketStore)

  /**
   * Job Insights view model.
   */
  jobInsightsVM = new JobInsightsViewModel(
    this.job,
    this.jobStore,
    this.jobInsightStore,
    this.conversationStore,
    this.newAlert,
  )

  /**
   * Admin job scope update view model.
   */
  updateJobScopeVM = new UpdateJobScopeViewModel(
    this.job,
    this.inventoryStore,
    this.job.workspace.id,
    this.jobStore,
  )

  /**
   * Request scope changes view model.
   */
  requestScopeChangesVM = new RequestScopeChangesViewModel(
    this.job,
    this.inventoryStore,
    this.job.workspace.id,
    (
      reason: string,
      changes: ScopeChangeParams[],
      inventoryChanges: ScopeChangeInventoryParams[],
    ) =>
      this.jobStore.requestScopeChanges(
        this.job,
        reason,
        changes,
        inventoryChanges,
      ),
    () => this.revealEventsSubject.next(undefined),
    this.getCurrentMember,
  )

  /**
   * Request scope changes view model.
   */
  viewScopeChangeRequestVM = new ViewScopeChangesViewModel()

  /**
   * Copy view model.
   */
  copyVM = new CopyJobViewModel(
    this.job,
    this.newAlert,
    this.jobStore.copyJob.bind(this.jobStore),
  )

  /**
   * Message Bank view model
   */
  messageBankDialogVM = this.createMessageBankDialogViewModel(
    () => Id.assert(this.job.workspace.id),
    this.conversationVM.setComposerText.bind(this.conversationVM),
  )

  /**
   * Close Job as Admin Dialog View Model.
   */
  closeJobAsAdminDialogVM = new CloseJobAsAdminDialogViewModel(
    this.job,
    this.jobStore,
    CloseJobDialogAdapter(this.billingStore, this.job),
    () => this.getCurrentMember(this.job.workspace.id),
  )

  /**
   * Split Payout dialog view model, for defining payout allocations.
   */
  splitPayoutDialogVM = new SplitPayoutDialogViewModel(
    this.job,
    this.findMembers,
    this.jobStore,
    this.newAlert,
  )

  deleteJobDialogVM = new DeleteJobDialogViewModel(
    this.job,
    this.jobStore,
    this.router,
    this.newAlert,
  )

  /**
   * View Model for the Notify Pros of Open Job Dialog.
   */
  notifyProsOfOpenJobDialogVM = new NotifyProsOfOpenJobDialogViewModel(
    this.job,
    this.jobStore,
    this.newAlert,
  )

  /**
   * Submit job dialog view model.
   */
  submitJobDialogVM = new SubmitJobDialogViewModel(
    this.job,
    new SubmitJobDialogAdapter(this.jobStore),
    this.newAlert,
    this.canUpdateJobAsAdmin,
  )

  /**
   * Add Manual Invoice dialog view model, for submitting invoices to .net.
   */
  addManualInvoiceDialogVM = new AddManualInvoiceDialogViewModel(
    this.job,
    this.jobStore,
    this.newAlert,
  )

  /**
   * Charges or refunds dialog view model, for submitting charges or refunds to .net.
   */
  chargeOrRefundDialogVM = new ChargeOrRefundDialogViewModel(
    this.job,
    this.teamStore,
    this.jobStore,
    () => this.availableBillingMethods,
    this.newAlert,
  )

  /**
   * Dialog for updating deadlines.
   */
  updateDeadlineDialogVM = new UpdateDeadlineDialogViewModel(
    this.job,
    this.jobStore,
    this.newAlert,
  )

  /**
   * View model for the service item list dialog.
   */
  serviceItemListVM = new ServiceItemListViewModel(
    this.job.jobScopeItems,
    this.jobWorkspace.id,
    this.getCurrentMember,
  )

  /**
   * Dialog for setting the job's progression step.
   */
  updateProgressionStepDialogVM = new UpdateProgressionStepDialogVM(
    this.jobProgressionVM,
    this.newAlert,
  )

  bookkeepingProgressionVM = new BookkeepingProgressionViewModel(
    this.bookkeepingProgressionStore,
    this.jobStore,
    this.requestScopeChangesVM,
    this.job,
    this.newAlert,
  )

  bookkeepingCorrectCycleDialogVM = new BookkeepingCorrectCycleDialogViewModel(
    this.newAlert,
    this.job.id,
    this.bookkeepingProgressionStore,
    this.showSelectCycleDialog.bind(this),
  )

  bookkeepingSelectCycleDialogVM = new BookkeepingSelectCycleViewModel(
    this.job.id,
    this.bookkeepingProgressionStore,
    this.bookkeepingCorrectCycleDialogVM,
  )

  documentRequestDialogVM = new DocumentRequestDialogViewModel(
    this.job.id,
    this.supportingItemsAdapter,
    this.documentRequestStore,
    this.newAlert,
    () => this.checklist,
  )

  incompleteConsultationCompletionDialogVM =
    new IncompleteConsultationCompletionDialogViewModel(
      this.requestCloseWithIncompleteConsultation.bind(this),
    )

  txfJobViewModel = new TxfJobViewModel(
    this.job,
    this.getCurrentMember,
    this.txfJobStore,
    this.documentStore,
  )

  /**
   * The current tab in the sidebar.
   */
  @observable currentTab = Tab.Details

  constructor(
    private router: Router,
    private newAlert: AlertFactory,
    private jobStore: JobStore,
    private consultationStore: ConsultationStore,
    private jobTicketStore: JobTicketStore,
    private jobInsightStore: InsightStore,
    private progressionStore: JobProgressionStore,
    private availableJobProgressionFlowsStore: AvailableJobProgressionFlowsStore,
    private desktopNotificationStore: DesktopNotificationStore,
    private milestoneStore: MilestoneStore,
    private documentStore: DocumentStore,
    private billingStore: BillingStore,
    private documentVersionStore: DocumentVersionStore,
    private documentAccessStore: DocumentAccessStore,
    private createQuestionsQuerySession: () => QuestionsQuerySession,
    private findTeamMembersByUserPublicId: FindUserTeamMembersByUserPublicId,
    private fetchTeamMember: FetchTeamMember,
    private findMembers: FindMembers,
    private findTeamMembers: FindTeamMembers,
    private providerStore: ProviderStore,
    private createConversationViewModel: ConversationViewModelFactory,
    private shortcuts: Shortcuts,
    private _requestClose: (job: Job) => unknown,
    public job: Job,
    private getCurrentMember: GetCurrentMember,
    private viewDocumentDetails: ViewDocumentDetailsDelegate,
    private selectPaymentMethod: SelectPaymentMethodDelegate,
    private jobDocumentsAdapter: JobDocumentsAdapter,
    private createMessageBankDialogViewModel: MessageBankDialogViewModelFactory,
    private sureprepStore: SureprepStore,
    private ensureTermsAccepted: EnsureTermsAccepted,
    private conversationStore: ConversationStore,
    private couponStore: CouponStore,
    private inventoryStore: InventoryStore,
    private _canEditDraftJobAsAdmin: () => boolean,
    private questionStore: QuestionStore,
    private teamStore: TeamStore,
    private infoGatheringStore: InfoGatheringStore,
    public jobCreationDialogViewModel: CreateJobDialogViewModel,
    private getUserData: GetUserData,
    private canUpdateJobAsAdmin: boolean,
    private jobRatingStore: JobRatingsStore,
    public isPro: boolean,
    private bookkeepingProgressionStore: BookkeepingProgressionStore,
    private isFirmAdminInWorkspace: IsFirmAdminInWorkspace,
    private supportingItemsAdapter: SupportingItemsPorts,
    private documentRequestStore: DocumentRequestStore,
    private roomStore: RoomStore,
    private individualProfileStore: IndividualProfileStore,
    private businessProfileStore: BusinessProfileStore,
    private taxRefundMethodStore: TaxRefundMethodStore,
    public documentManualVerificationVM: DocumentManualVerificationViewModel,
    private txfJobStore: TxfJobStore,
    private getAddToCalendarDelegate: () => AddToCalendarDelegate,
    private getExternalUrlDelegate: () => ExternalUrlDelegate,
  ) {
    makeObservable(this)
    this.fetchTeamMemberForCurrentUser = once(
      this.fetchTeamMemberForCurrentUser.bind(this),
    )

    this.currentTab = Tab.Details
  }

  /**
   * Computes whether an active PTIN is required for the current member.
   *
   * @returns {boolean} Returns true if an active PTIN is required, otherwise false.
   */
  @computed
  get ptinRequired(): boolean {
    const featureEnabled = getFeatureToggleClient().variation(
      'Worklayer.RequireActivePTIN',
    )
    if (!featureEnabled) {
      return false
    }

    const userData = this.getUserData(this.getCurrentMember().user.publicId)

    return (
      userData?.userDataType === UserDataType.Pro &&
      userData?.ptinStatus === ProviderActivePtinStatusDto.Inactive
    )
  }

  @computed
  get hasConsultation() {
    return this.job.hasActiveConsultation
  }

  @computed
  get consultationIsPendingScheduling() {
    return (
      this.job.consultation?.isPendingBooking ||
      this.job.consultation?.isPendingAvailability
    )
  }

  @computed
  get consultationIsPendingAvailability() {
    return this.job.consultation?.isPendingAvailability
  }

  @computed
  get consultationIsPendingBooking() {
    return this.job.consultation?.isPendingBooking
  }

  @computed
  get consultationHasBookedTime() {
    return this.job.consultation?.bookedTime
  }

  @computed
  get isConsultationBookedAndActive() {
    return (
      this.consultationHasBookedTime &&
      (this.job.consultation?.status === ConsultationStatus.PendingCall ||
        this.job.consultation?.status === ConsultationStatus.InProgress)
    )
  }

  @computed
  get consultationPendingSchedulingText() {
    return this.job.consultation?.isPendingBooking
      ? 'Pending consultation scheduling'
      : this.job.consultation?.isPendingAvailability
        ? 'Customer availability selection pending'
        : ''
  }

  @computed
  get canFulfillConsultation() {
    return this.jobWorkspaceMember !== this.job.championClient?.member
  }

  /**
   * Available billing methods for charging or refunding.
   */
  @computed
  get availableBillingMethods() {
    if (!this.job.isBillingEnabled) {
      return []
    }

    if (this.job.ownerTeam) {
      return this.job.ownerTeam
        ? this.billingStore.billingMethodsForTeam(this.job.ownerTeam)
        : []
    }

    return this.billingStore.billingMethodsForIndividual(this.job.owner)
  }

  @computed
  get hasTasks() {
    return (
      this.hasMilestones &&
      this.milestonesVM.taskLists.some(
        (tl) =>
          tl.designee.toLowerCase() ===
          this.currentUserCollaborator?.type.toLowerCase(),
      )
    )
  }

  @computed
  get hasMilestones() {
    return this.milestonesVM.milestones.length > 0
  }

  @computed
  get productTour() {
    return this.hasTasks
      ? 'JobDetailsProductTourFull'
      : this.hasMilestones
        ? 'JobDetailsProductTourWithoutTasks'
        : 'JobDetailsProductTourWithoutMilestones'
  }

  /**
   * Whether desktop notifications are enabled.
   */
  @computed
  get areNotificationsEnabled() {
    return this.desktopNotificationStore.isEnabled
  }

  /**
   * Whether desktop notifications are denied.
   */
  @computed
  get areNotificationsDenied() {
    return this.desktopNotificationStore.isDenied
  }

  /**
   * The workspace that the job belongs to.
   */
  @computed
  get jobWorkspace() {
    return this.job.workspace
  }

  /**
   * The workspace member for the current user on the workspace
   * that the job belongs to.
   */
  @computed
  get jobWorkspaceMember() {
    return this.getCurrentMember(this.jobWorkspace.id) ?? Member.none
  }

  /**
   * All collaborators, including you.
   */
  @computed
  get collaborators() {
    return this.job.collaborators.map(this.createCollaboratorVM)
  }

  @computed
  get canUpdateJobProgressionAsClient() {
    return (
      this.championClient?.isCurrentUser ||
      isNotNil(this.currentTeamMemberOfOwnerTeam)
    )
  }

  @computed
  get isClientTeamJob() {
    return this.job.isClientTeamJob
  }

  @computed
  get canAddCollaboratorsAsAdmin() {
    return this.canAddProvidersAsAdmin || this.canAddClientsAsAdmin
  }

  /**
   * Determines whether we can add Providers on the job as Admin.
   */
  @computed
  get canAddProvidersAsAdmin() {
    return (
      this.job.canAddChampionProviderAsAdmin ||
      this.job.canAddSupportingProviderAsAdmin
    )
  }

  /**
   * Determines whether we can add Clients on the job as Admin.
   */
  @computed
  get canAddClientsAsAdmin() {
    return this.job.canAddSupportingClientAsAdmin
  }

  @computed
  get coupon() {
    if (this.job.couponCodes) {
      return this.couponStore.byCode(this.job.couponCodes)
    }
  }

  @computed
  get couponDisplay() {
    if (!this.coupon) {
      return ''
    }

    return `${this.coupon.code}-${this.coupon.discount}`
  }

  /**
   * Determines whether we can view coupon details.
   */
  @computed
  get canViewCoupon() {
    return (
      this.coupon &&
      (this.championClient?.isCurrentUser ||
        this.getCurrentMember(this.jobWorkspace.id).hasAllPermissions(
          'ADMIN_BILLING_MANAGE',
        ))
    )
  }

  /**
   * Determines whether we can add coupons to the job as Admin.
   */
  @computed
  get canAddCouponAsAdmin() {
    return !this.coupon && this.job.canManageCouponAsAdmin
  }

  /**
   * Determines whether we can remove coupons from the job as Admin.
   */
  @computed
  get canRemoveCouponAsAdmin() {
    return this.coupon && this.job.canManageCouponAsAdmin
  }

  /**
   * Determines whether we can remove pros as Admin.
   */
  @computed
  get canRemoveProsAsAdmin() {
    return (
      this.supportingPros.length > 0 && this.job.canRemoveSupportingProsAsAdmin
    )
  }

  /**
   * Determines whether we can remove clients as Admin.
   */
  @computed
  get canRemoveClientsAsAdmin() {
    return (
      this.supportingClients.length > 0 &&
      this.job.canRemoveSupportingClientsAsAdmin
    )
  }

  /**
   * Determines whether we can remove collaborators as Admin.
   */
  @computed
  get canRemoveCollaboratorsAsAdmin() {
    return (
      (this.supportingClients.length > 0 || this.supportingPros.length > 0) &&
      (this.job.canRemoveSupportingClientsAsAdmin ||
        this.job.canRemoveSupportingProsAsAdmin)
    )
  }

  /**
   * Determines whether we can add clients as a team member.
   */
  @computed
  get canAddClientsAsTeamMember() {
    return this.job.canAddClientsAsTeamMember
  }

  /**
   * Determines whether we can remove clients as a team member.
   */
  @computed
  get canRemoveClientsAsTeamMember() {
    return this.job.canRemoveClientsAsTeamMember
  }

  /**
   * Determines whether we can remove clients as a client.
   */
  @computed
  get canRemoveClientsAsCollaborator() {
    return this.job.canRemoveClientsAsCollaborator
  }

  /**
   * Determines whether we can remove clients as a non-admin.
   */
  @computed
  get canRemoveClientsAsNonAdmin() {
    return (
      this.canRemoveClientsAsTeamMember || this.canRemoveClientsAsCollaborator
    )
  }

  /**
   * Determines whether we can view the collaborators action menu
   */
  @computed
  get canViewCollaboratorActionsMenu() {
    return (
      this.canAddCollaboratorsAsAdmin ||
      this.ratingsVM.canRatePro ||
      this.canRemoveCollaboratorsAsAdmin ||
      this.canAddClientsAsTeamMember ||
      this.canRemoveClientsAsTeamMember ||
      this.canRemoveClientsAsCollaborator
    )
  }

  /**
   * Determines whether we can view the requested provider action menu
   */
  @computed
  get canViewRequestedProviderActionsMenu() {
    return this.job.canRequestChampionProviderAsAdmin
  }

  /**
   * Whether we can settle balance.
   */
  @computed
  get canSettleBalance() {
    return this.job.canSettleBalance
  }

  /**
   * Job scope change requests.
   */
  @computed
  get scopeChangeRequests() {
    return this.jobStore.scopeChangesForJob(this.job)
  }

  /**
   * Whether the job have a pending scope change request.
   */
  @computed
  get isScopeChangeRequestPending() {
    return this.scopeChangeRequests.some((jscr) => jscr.isPending)
  }

  /**
   * Whether the user can update the job scope.
   */
  @computed
  get canUpdateJobScope() {
    if (!this.job.canUpdateJobScope) {
      return false
    }

    if (!this.scopeChangeRequests.length) {
      return true
    }

    return this.scopeChangeRequests.every(
      (scopeChange) =>
        scopeChange.status === 'Accepted' ||
        scopeChange.status === 'Rejected' ||
        scopeChange.status === 'ApplyFailed',
    )
  }

  /**
   * Whether we can request scope changes.
   */
  @computed
  get canRequestScopeChanges() {
    if (!this.job.canRequestScopeChanges) {
      return false
    }

    if (!this.scopeChangeRequests.length) {
      return true
    }

    return this.scopeChangeRequests.every(
      (scopeChange) =>
        scopeChange.status === 'Accepted' ||
        scopeChange.status === 'Rejected' ||
        scopeChange.status === 'ApplyFailed',
    )
  }

  /**
   * The text we show when there is a pending action on the job.
   */
  @computed
  get pendingActionsText() {
    return this.isScopeChangeRequestPending
      ? 'Pending job scope changes'
      : 'Pending call completion'
  }

  /**
   * Formats the legend name and the legend version.
   */
  @computed
  get legendText() {
    return `${this.job.legendName} V${this.job.legendVersionId.version}`
  }

  /**
   * Whether we can copy the job.
   */
  @computed
  get canCopy() {
    return this.job.canCopy
  }

  /**
   * Whether the new job progression config is being used.
   */
  @computed
  get usingNewJobProgressionConfig() {
    return getFeatureToggleClient().variation(
      'HQ.UseUpdatedJobProgressionConfig',
    )
  }

  /**
   * Whether insights workspace config is enabled.
   */
  @computed
  get isInsightsWorkspaceConfigEnabled() {
    return this.jobWorkspace.config.insights_config?.enabled ?? false
  }

  /**
   * Whether we are allowed to view the payout split.
   */
  @computed
  get canViewPayoutSplit() {
    return this.job.canViewPayoutSplit
  }

  /**
   * Whether we can split the payout for the job.
   */
  @computed
  get canSplitPayout() {
    return this.job.canSplitPayout
  }

  @computed
  get canDeleteJobAsAdmin() {
    return this.job.canDeleteJobAsAdmin
  }

  @computed
  get canDeleteJobAsCollaborator() {
    return this.job.canDeleteJobAsCollaborator
  }

  /**
   * Indicates whether the actor can notify pros of the available job.
   */
  @computed
  get canNotifyPros() {
    return this.job.canNotifyPros
  }

  /**
   * Whether the current user is allowed to view the payment distribution section.
   */
  @computed
  get canViewPaymentDistributionAsAdmin() {
    return this.job.canViewPaymentDistributionAsAdmin
  }

  /**
   * Job's purchase transactions.
   */
  @computed
  get jobPurchaseTransactions() {
    if (!this.job) {
      return []
    }

    return this.billingStore
      .filterBillingTransactionsByIds(this.job.stripeCharges)
      .filter((x) => x && x.isPurchase && x.metadata.receipt_url)
  }

  /**
   * Job's refund transactions.
   */
  @computed
  get jobRefundTransactions() {
    if (!this.job) {
      return []
    }

    return this.billingStore
      .filterBillingTransactionsByIds(this.job.stripeRefunds)
      .filter((x) => x && x.isRefund)
  }

  /**
   * Job's total refund amount, calculated by summing up all refund transactions
   * related to the job.
   */
  @computed
  get jobRefundTransactionAmount() {
    return (
      this.jobRefundTransactions.reduce((total, transaction) => {
        return total + transaction.amount
      }, 0) / 100
    )
  }

  /**
   * Whether we can reopen the job.
   */
  @computed
  get canReopenAsAdmin() {
    return this.job.canReopenAsAdmin
  }

  /**
   * Determines whether we can rename the job.
   */
  @computed
  get canRename() {
    return this.job.canRename
  }

  /**
   * Determines whether we can view amendments for the job.
   */
  @computed
  get canViewAmendments() {
    return this.job.canViewAmendments
  }

  /**
   * Whether we are able to close the job as a collaborator.
   */
  @computed
  get canCloseAsCollaborator() {
    return this.job.canCloseAsCollaborator
  }

  /**
   * Whether we are able to close the job as an admin.
   */
  @computed
  get canCloseAsAdmin() {
    return this.job.canCloseAsAdmin
  }

  /**
   * Whether we are able to make any transfer in a job.
   */
  @computed
  get canTransferJobAsAdmin() {
    return this.job.hasActiveConsultation
      ? (this.isClaimedJob || this.job.isOnHold) &&
          this.job.canTransferJobAsAdmin
      : this.job.canTransferJobAsAdmin
  }

  /**
   * Whether we are able to add invoices manually.
   */
  @computed
  get canAddManualInvoice() {
    return this.job.canAddInvoice
  }

  /**
   * Whether we are able to manage billing.
   */
  @computed
  get canManageBilling() {
    return this.job.canManageBilling
  }

  /**
   * Whether we are able to charge/refund a job.
   */
  @computed
  get canChargeOrRefundJob() {
    return (
      this.job.canChargeOrRefundJob && this.availableBillingMethods.length > 0
    )
  }

  /**
   * Returns the bookkeeping progression info if it's a bookkeeping job.
   */
  @computed
  get bookkeepingProgressionInfo() {
    return this.bookkeepingProgressionStore.getBookkeepingProgressionInfo(
      this.job.id,
    )
  }

  /**
   * Returns the completed cycles if it's a bookkeeping job.
   */
  @computed
  get completedBookkeepingCycles() {
    return (
      this.bookkeepingProgressionInfo?.cycles.filter((c) => c.isCompleted) || []
    )
  }

  /**
   * Whether we are able to correct bookkeeping cycles.
   */
  @computed
  get canCorrectBookkeepingCycles() {
    return (
      this.job.canCorrectBookkeepingCycles &&
      Boolean(this.completedBookkeepingCycles.length)
    )
  }

  /**
   * Whether we are able to download the binder.
   */
  @computed
  get canDownloadBinder() {
    return this.job.canDownloadBinder
  }

  /**
   * Whether we are able to update the job deadline.
   */
  @computed
  get canUpdateDeadline() {
    return this.job.canUpdateDeadline
  }

  /**
   * Whether we are able to transfer the job to pool as an admin.
   */
  @computed
  get canTransferToPoolAsAdmin() {
    return this.job.canTransferToPoolAsAdmin
  }

  /**
   * Whether we are able to remove the client team from the job as an admin.
   */
  @computed
  get canRemoveClientTeamAsAdmin() {
    return this.job.canRemoveClientTeamAsAdmin
  }

  /**
   * Whether we are able to make corrections.
   */
  @computed
  get canMakeCorrections() {
    return this.job.canMakeCorrections
  }

  /**
   * Whether can transfer to client.
   */
  @computed
  get canTransferToClientAsAdmin() {
    return this.job.canTransferToClientAsAdmin
  }

  /**
   * Whether can transfer to pro.
   */
  @computed
  get canTransferToProAsAdmin() {
    return this.job.canTransferToProAsAdmin
  }

  /**
   * Whether can transfer to client team.
   */
  @computed
  get canTransferToClientTeamAsAdmin() {
    return this.job.canTransferToClientTeamAsAdmin
  }

  /**
   * Whether forfeiting is enabled.
   */
  @computed
  get canForfeit() {
    return this.job.canForfeit
  }

  @computed
  get isOnHold() {
    return this.job.isOnHold
  }

  @computed
  get isClaimedJob() {
    return this.job.isClaimedJob
  }

  @computed
  get completed() {
    return this.job.completed
  }

  @computed
  get canPutJobOnHold() {
    return this.job.canPutJobOnHold && this.isClaimedJob
  }

  @computed
  get canResumeJob() {
    return this.job.canResumeJob && this.isOnHold
  }

  /**
   * Collaborators on the job that are not you.
   */
  @computed
  get otherCollaborators() {
    const current = this.currentUserCollaborator
    return this.collaborators.filter((c) => c !== current)
  }

  /**
   * Collaborator for the current user.
   */
  @computed
  get currentUserCollaborator() {
    return this.collaborators.find((c) => c.isCurrentUser)
  }

  /**
   * Champion pro collaborator
   */
  @computed
  get championPro() {
    return this.collaborators.find(
      (c) => c.role === 'CHAMPION' && c.type === 'PROVIDER',
    )
  }

  /**
   * Champion client collaborator
   */
  @computed
  get championClient() {
    return this.collaborators.find(
      (c) => c.role === 'CHAMPION' && c.type === 'CLIENT',
    )
  }

  /**
   * Supporting Pros on the Job.
   */
  @computed
  get supportingPros() {
    return this.job.supportingPros
  }

  /**
   * Supporting Clients on the Job.
   */
  @computed
  get supportingClients() {
    return this.job.supportingClients
  }

  /**
   * Whether the current user is a Provider-role collaborator.
   */
  @computed
  get isProviderCollaborator() {
    return this.job.isProviderCollaborator
  }

  /**
   * Whether the current user is a champion Client-role collaborator.
   */
  @computed
  get isChampionClientCollaborator() {
    return this.job.isChampionClientCollaborator
  }

  /**
   * Whether the current user is a supporting Client-role collaborator.
   */
  @computed
  get isSupportingClientCollaborator() {
    return this.job.isSupportingClientCollaborator
  }

  /**
   * Whether the current user can approve the draft as a supporting client.
   */
  @computed
  get canApproveDraftAsSupportingClient() {
    const currentMember = this.supportingClients.find(
      (c) => c.member.isCurrentUser,
    )

    return currentMember?.member.hasPermission(
      'SUPPORTING_CLIENT_JOB_PROGRESSION_APPROVE_DRAFT',
    )
  }

  @computed
  get canSetReadyToFile() {
    return this.jobWorkspaceMember.hasPermission(
      'ADMIN_JOB_PROGRESSION_APPROVE_DRAFT',
    )
  }

  /**
   * Current team member of owner team.
   */
  @computed
  get currentTeamMemberOfOwnerTeam() {
    return this.job.currentTeamMemberOfOwnerTeam
  }

  /**
   * The subject to check permissions against.
   */
  @computed
  get permissionSubject(): PermissionSubject {
    return this.job.permissionSubject
  }

  /**
   * Gets the status text.
   */
  @computed
  get statusText() {
    switch (this.job.status) {
      case 'UNDER_CONSTRUCTION':
        return 'Onboarding'
      case 'INFO_GATHERING':
        return 'Info Gathering'
      case 'UNCLAIMED':
        return 'Unclaimed'
      case 'CLAIMED':
        return this.nextMilestone ? this.nextMilestone.title : 'In Progress'
      case 'CLOSED':
        return 'Completed'
      case 'ON_HOLD':
        return 'On hold'
    }
  }

  /**
   * Gets the milestone pending completion, if any.
   */
  @computed
  get nextMilestone() {
    return this.milestonesVM.nextMilestone || null
  }

  /**
   * Unfinished task count for the current user in the current milestone.
   */
  @computed
  get unfinishedTaskCount() {
    const milestone = this.nextMilestone
    const vm = this.currentUserCollaborator
    if (!milestone || !vm) {
      return 0
    }

    const tasksForMe = milestone.tasks.filter(
      (t) =>
        !t.completed &&
        (t.designee === 'Client'
          ? vm.collaborator.type === 'CLIENT'
          : vm.collaborator.type === 'PROVIDER'),
    )

    return tasksForMe.length
  }

  /**
   * Whether the user can upload documents to the job
   */
  @computed
  get canUploadDocs() {
    return (
      this.jobWorkspaceMember.hasSomePermissions(
        'DOCS_UPLOAD',
        'ADMIN_DOCUMENT_MANAGE',
      ) && this.job.status !== 'CLOSED'
    )
  }

  /**
   * Whether the user can view the documents
   */
  @computed
  get canViewDocs() {
    return this.jobWorkspaceMember.hasSomePermissions(
      'DOCS_VIEW',
      'ADMIN_DOCUMENT_MANAGE',
    )
  }

  /**
   * Whether the user can view the job scope change requests
   */
  @computed
  get canViewScopeChangeRequests() {
    return (
      this.job.canRequestScopeChanges ||
      this.job.canUpdateJobScope ||
      this.job.canViewScopeChangeRequests
    )
  }

  /**
   * Amount of days left to complete the job
   */
  @computed
  get daysLeft() {
    if (this.job.dateDeadline === null) {
      return ' '
    }
    const diff = differenceInDays(this.job.dateDeadline, toDate(Date.now()))
    if (Math.abs(diff) === 1) {
      return diff > 0 ? `1 day` : `1 day ago`
    }
    return diff > 0 ? `${diff} days` : `${diff * -1} days ago`
  }

  /**
   * Job duration stat depending on Job Status.
   */
  @computed
  get statusHistorySummary(): StatusHistorySummaryType | null {
    if (
      this.job.status === 'UNDER_CONSTRUCTION' &&
      this.job.dateCreated !== null
    ) {
      const timeAgo = timeago(this.job.dateCreated, 'long')
      const isRightNow = timeAgo === 'now'

      return {
        prefix: 'Job created',
        time: isRightNow ? `right ${timeAgo}` : timeAgo,
        suffix: isRightNow ? '' : 'ago',
      }
    }

    if (
      (this.job.status === 'ON_HOLD' || this.job.status === 'IDLE') &&
      this.job.dateLastActivity !== null
    ) {
      const timeAgo = timeago(this.job.dateLastActivity, 'long')
      const isRightNow = timeAgo === 'now'

      return {
        prefix: 'No activity since',
        time: isRightNow ? `right ${timeAgo}` : timeAgo,
        suffix: isRightNow ? '' : 'ago',
      }
    }

    if (this.job.status !== 'CLOSED' && this.job.dateAccepted !== null) {
      const timeAgo = timeago(this.job.dateAccepted, 'long')
      const isRightNow = timeAgo === 'now'

      return {
        prefix: 'Job accepted',
        time: isRightNow ? `right ${timeAgo}` : timeAgo,
        suffix: isRightNow ? '' : 'ago',
      }
    }

    if (
      this.job.status === 'CLOSED' &&
      this.job.dateAccepted !== null &&
      this.job.dateClosed !== null
    ) {
      const timeAgo = timeago(
        this.job.dateAccepted,
        'long',
        this.job.dateClosed,
      )
      const isRightNow = timeAgo === 'now'

      return {
        prefix: 'Job took',
        time: isRightNow ? 'less then a second' : timeAgo,
        suffix: 'to complete',
      }
    }

    if (this.job.status === 'UNCLAIMED' && this.job.dateSubmitted !== null) {
      const timeAgo = timeago(this.job.dateSubmitted, 'long')
      const isRightNow = timeAgo === 'now'

      return {
        prefix: 'Job submitted',
        time: isRightNow ? `right ${timeAgo}` : timeAgo,
        suffix: isRightNow ? '' : 'ago',
      }
    }

    return null
  }

  /**
   * Whether the user can view the job's insights.
   */
  @computed
  get canViewJobInsights() {
    const insightsWorkspaceConfig = this.isInsightsWorkspaceConfigEnabled
    const insightsPermission = this.job.canViewInsights
    const isJobNotUnclaimedOrUnderConstruction =
      this.job.status !== 'INFO_GATHERING' &&
      this.job.status !== 'UNCLAIMED' &&
      this.job.status !== 'UNDER_CONSTRUCTION'

    return (
      insightsWorkspaceConfig &&
      insightsPermission &&
      isJobNotUnclaimedOrUnderConstruction
    )
  }

  /**
   * Whether the user can remove documents
   */
  @computed
  get canRemoveDocs() {
    return this.documentsVM.canRemoveDocs
  }

  /**
   * Whether the user can download documents
   */
  @computed
  get canDownloadDocs() {
    return this.jobWorkspaceMember.hasSomePermissions('DOCS_UPLOAD')
  }

  @computed
  get hasAnyDocPermission() {
    return this.canViewDocs || this.canUploadDocs
  }

  /**
   * Whether there are selected documents
   */
  @computed
  get hasDocumentsSelected() {
    return this.documentsVM.selectedDocuments.size > 0
  }

  /**
   * Whether the user can manage the conversation
   */
  @computed
  get hasConversationManagePermission() {
    return this.jobWorkspaceMember.hasPermission('ADMIN_CONVERSATION_MANAGE')
  }

  /**
   * Whether the job progression flow is enabled.
   */
  @computed
  get isProgressionFlowEnabled() {
    if (this.job.jobType?.type !== 'TAX') {
      return false
    }

    if (this.usingNewJobProgressionConfig) {
      return (
        this.jobWorkspace.features.jobProgressionConfig.enabled &&
        this.jobWorkspace.features.jobProgressionConfig.legends[
          this.job.legendId
        ] &&
        this.jobWorkspace.features.jobProgressionConfig.legends[
          this.job.legendId
        ] !== 'NONE'
      )
    }

    return this.jobWorkspace.features.jobConfig.jobProgressionConfig
  }

  /**
   * Participant member to display in the chat's conversation header.
   */
  @computed
  get participantMemberToDisplay() {
    // Show champion pro participant if we are the client, otherwise show the client
    return this.currentUserCollaborator?.type === 'CLIENT'
      ? this.championPro?.collaborator.member
      : this.championClient?.collaborator.member
  }

  /**
   * Whether the user can see the last seen information in the chat.
   */
  @computed
  get canViewLastSeenInfoInChat() {
    return this.jobWorkspaceMember.hasSomePermissions(
      'ADMIN_USER_READ',
      'ADMIN_USER_MODIFY',
    )
  }

  /**
   * Whether the current member is able to edit the draft as a user with permission ADMIN_JOB_CREATE.
   */
  @computed
  get canEditDraftJobAsAdmin() {
    return this._canEditDraftJobAsAdmin()
  }

  /**
   * Whether the current member is able to edit the draft in job details.
   */
  @computed
  get useEditDraftJobForFirmAdmin() {
    return this.isFirmAdminInWorkspace(this.job.workspace.id)
  }

  /**
   * Determine that we are gathering that info for the job.
   */
  @computed
  get isInfoGatheringStep() {
    return this.job.status === 'INFO_GATHERING'
  }

  /**
   * Whether consultation card is visible
   */
  @computed
  get showConsultationCard() {
    return this.hasConsultation && this.canFulfillConsultation
  }

  /**
   * Whether call card is always visible
   */
  @computed
  get showCallCard() {
    return (
      this.job.alwaysEnableVoiceCall &&
      !this.showConsultationCard &&
      this.job.status !== 'UNDER_CONSTRUCTION' &&
      this.job.status !== 'CLOSED'
    )
  }

  @computed
  get canCompleteJobProgression() {
    const canComplete =
      (this.showConsultationCard && this.isProgressionFlowEnabled) ||
      (this.isProgressionFlowEnabled && !this.showConsultationCard)

    return canComplete && !this.isScopeChangeRequestPending
  }

  /**
   * The checklist of supporting items for the job.
   */
  @computed
  get checklist() {
    return this.infoGatheringStore.checklists.get(this.job.id)
  }

  @computed
  get hasCompletedChecklistItem() {
    return (
      Boolean(this.checklist?.businessInfoSection?.completedCount) ||
      Boolean(this.checklist?.personalInfoSection?.completedCount)
    )
  }

  /**
   * Whether the scheduled provider should be shown in the collaborators section.
   */
  @computed
  get showingRequestedProvider() {
    return (
      this.job.requestedPro &&
      !this.job.proChampion &&
      (this.job.status === 'UNDER_CONSTRUCTION' ||
        this.isInfoGatheringStep ||
        this.job.status === 'UNCLAIMED')
    )
  }

  /**
   * Whether the current user can override the job progression flow.
   */
  @computed
  get canOverrideJobProgressionStep() {
    return (
      !this.completed &&
      this.jobProgressionVM.hasStarted &&
      this.jobProgressionVM.overrideableProgressionSteps.length > 0 &&
      this.jobWorkspaceMember.hasPermission('ADMIN_JOB_UPDATE')
    )
  }

  /**
   * Whether the current user can complete info gathering supporting items on
   * a client's behalf.
   */
  @computed
  get canEditCapturedInfo() {
    return this.jobWorkspaceMember.hasSomePermissions(
      'WORKSPACE_JOB_INFO_GATHERING_UPDATE',
      'ADMIN_JOB_UPDATE',
    )
  }

  @computed
  get isBookkeepingEnabled() {
    return this.job.jobType?.type === 'BOOKKEEPING' && isBookkeepingEnabled()
  }

  @computed
  get visibleCard() {
    if (
      this.job.status !== 'UNDER_CONSTRUCTION' &&
      this.bookkeepingProgressionVM.isBookkeepingEnabled
    ) {
      return 'BOOKKEEPING_CARD'
    }

    if (this.showDraftView) {
      return 'COMPLETE_ONBOARDING_CARD'
    }

    if (this.isInfoGatheringStep) {
      return 'INFO_GATHERING_CARD'
    }

    if (this.showConsultationCard) {
      if (this.isProgressionFlowEnabled) {
        return 'JOB_PROGRESSION_CONSULTATION_CARD'
      }
      return 'CONSULTATION_CALL_CARD'
    }

    if (this.isProgressionFlowEnabled) {
      return 'JOB_PROGRESSION_CARD'
    }

    return 'TASK_CARD'
  }

  /**
   * Whether the user should see the draft job details.
   */
  @computed
  get showDraftView() {
    return this.job.isDraft
  }

  /**
   * Whether the job's questions has ben completed
   */
  @computed
  get questionsCompleted() {
    return this.detailsVM.questionsCompleted
  }

  /**
   * Returns the number of service items related to the job.
   */
  @computed
  get serviceItemsListLength() {
    return this.serviceItemListVM.serviceItems.length
  }

  /**
   * Opens job creation dialog.
   */
  @action.bound
  editDraft() {
    this.jobCreationDialogViewModel.open([this.job.id])
  }

  /**
   * Set the current tab.
   * @param tab
   */
  @action.bound
  setTab(tab: Tab) {
    this.currentTab = tab
  }

  /**
   * Requests to show the close dialog for use by non-admins.
   */
  @action.bound
  requestCloseAsCollaborator() {
    // Criteria for establishing that a job is a tax-type job with an incomplete consultation.
    const taxTypeJobWithIncompleteConsultation =
      this.isProgressionFlowEnabled &&
      this.job.jobType?.type === 'TAX' &&
      this.showConsultationCard &&
      !this.job.consultation?.hadRoomSession

    // Prevent closing tax-type jobs with an incomplete consultation.
    if (taxTypeJobWithIncompleteConsultation) {
      this.incompleteConsultationCompletionDialogVM.show()
      return
    }

    this._requestClose(this.job)
  }

  /**
   * Requests closing the job when the job has an incomplete consultation.
   */
  requestCloseWithIncompleteConsultation(
    consultationIncompleteReason: ConsultationIncompleteReason,
    consultationIncompleteOtherReason?: string,
  ) {
    if (
      !consultationIncompleteReason ||
      (consultationIncompleteReason === ConsultationIncompleteReason.Other &&
        !consultationIncompleteOtherReason)
    ) {
      return
    }

    this.jobStore.close(this.job, {
      reason: consultationIncompleteReason,
      otherReason: consultationIncompleteOtherReason,
    })
  }

  /**
   * Fetches job scope change requests.
   */
  listJobScopeChanges = task(() => {
    if (
      this.job.canViewScopeChangeRequests ||
      this.job.canRequestScopeChanges ||
      this.job.canUpdateJobScope
    ) {
      this.jobStore.listScopeChangesForCollaborator(this.job.id)
    }
  })

  /**
   * Fetches job coupons.
   */
  fetchCoupon = task(async () => {
    if (!this.job.couponCodes) {
      return
    }

    await this.couponStore.fetchCouponByCode(
      this.job.couponCodes,
      this.job.workspace.id,
    )
  })

  /**
   * Requests to show the close dialog for use by admins.
   */
  @action.bound
  requestCloseAsAdmin() {
    if (this.canCloseAsAdmin) {
      this.closeJobAsAdminDialogVM.show()
    }
  }

  @action.bound
  viewScopeChangeRequests(scopeChangeRequest: JobScopeChangeRequest) {
    this.viewScopeChangeRequestVM.set(scopeChangeRequest)
    this.viewScopeChangeRequestVM.show()
  }

  async placeJobOnHold() {
    const alert = this.newAlert()
      .withState(AlertState.Pending)
      .saying('Placing this job on hold', 'hang tight!')
      .show()
    try {
      await this.jobStore.placeJobOnHold(Id.assert(this.job.id))
      alert
        .withState(AlertState.Success)
        .saying('Success!', 'Job has been placed on hold!')
    } catch (e) {
      console.error(e)
      alert
        .withState(AlertState.Error)
        .saying('Failed!', 'Could not place this job on hold.')
    }
  }

  showSelectCycleDialog() {
    this.bookkeepingSelectCycleDialogVM.show()
  }

  /**
   * Resume a job that is on hold
   */
  async resumeJob() {
    const alert = this.newAlert()
      .withState(AlertState.Pending)
      .saying('Resuming this job', 'Hang tight!')
      .show()
    try {
      await this.jobStore.resumeJob(Id.assert(this.job.id))
      alert
        .withState(AlertState.Success)
        .saying('Success!', 'Job has been resumed!')
    } catch (e) {
      console.error(e)
      alert
        .withState(AlertState.Error)
        .saying('Failed!', 'Could not resume this job.')
    }
  }

  /**
   * Enables notifications.
   */
  enableNotifications() {
    this.desktopNotificationStore.setEnabled(true)
  }

  /**
   * Downloads binder for job
   */
  async downloadBinder() {
    const alert = this.newAlert()
      .withState(AlertState.Pending)
      .saying('Getting the Binder from Sureprep', 'Hang tight!')
      .show()

    return await this.sureprepStore
      .downloadBinder(this.job.id)
      .then(() => {
        alert
          .withState(AlertState.Success)
          .saying(
            `Binder has been received!`,
            `Your download will begin shortly.`,
          )
          .autoDismiss()
          .show()
      })
      .catch(() => {
        alert
          .withState(AlertState.Error)
          .saying('Failed to get Sureprep Binder')
          .autoDismiss()
          .show()
      })
  }

  async activateBookkeeping() {
    if (this.isBookkeepingEnabled) {
      this.bookkeepingProgressionVM.activate()
    }
  }

  async activateJobProgression() {
    if (this.isProgressionFlowEnabled) {
      this.jobProgressionVM.activate()
    }
  }

  /**
   * Called when the view loads.
   */
  activate = task.resolved(async () => {
    this.conversationVM.activate()
    this.documentsVM.activate()
    this.fetchChecklist()
    this.detailsVM.activate()
    this.activateJobProgression().then()
    this.jobTicketsVM.activate().then()
    if (this.canViewJobInsights) {
      this.jobInsightsVM.activate()
    }
    this.subscription = new Subscription()
    this.subscription.add(this.shortcuts.rename$.subscribe(this.renameVM.show))
    this.subscription.add(this.revealEvents$.subscribe())
    this.subscription.add(
      this.job.statusChange$.subscribe(this.listJobScopeChanges),
    )

    this.subscription.add(
      this.roomStore.events$
        .pipe(
          filter((e) => e.type !== 'Unknown'),
          filter((e) => e.room.conversation.id === this.job.conversation?.id),
          filter((e) => e.room.id !== this.job.consultation?.room.id),
          // Seems we are desync'd, see if fetching the job helps
          tap(() => this.jobStore.refreshJob(this.job.id)),
        )
        .subscribe(),
    )

    await this.activateBookkeeping()

    this.subscription.add(
      merge(
        this.jobStore.jobScopeChangeApproved$,
        this.job.statusChange$,
        this.jobStore.adminJobScopeUpdatedEvents$,
      )
        .pipe(
          switchMap(async (_) => {
            // Refetch the job progression in the background when the job scope change is approved
            // as the flow might have changed due to the scope change.
            this.activateJobProgression().then()
            return await this.jobStore.refreshJob(this.job.id)
          }),
          tap((job) =>
            this.serviceItemListVM.setJobScopeItems(job.jobScopeItems),
          ),
        )
        .subscribe(),
    )

    this.subscription.add(
      // Re-fetch the progression when we receive a progression update through chat.
      // TODO: Remove this when we have realtime updates for progression steps
      this.conversationStore.newMessages$
        .pipe(
          filter((m) => m.content.type === 'Progression'),
          concatMap(() => this.progressionStore.fetchProgression(this.job.id)),
        )
        .subscribe(),
    )

    this.subscription.add(this.job.couponChange$.subscribe(this.fetchCoupon))

    await this.fetchTeamMemberForCurrentUser()
    await this.ensureTermsAcceptedForJob()
    await this.fetchBillingTransactions()

    if (this.jobWorkspaceMember.hasPermission('ADMIN_BILLING_MANAGE')) {
      await this.fetchBillingMethods()
    }

    this.subscription.add(
      this.submitJobDialogVM.submitted$.subscribe(() => {
        // we are using a factory to create the conversationVM, we need to
        // set the conversation on the VM after the job has been submitted.
        this.conversationVM.setConversation(
          this.job.conversation ?? Conversation.none,
        )

        // Fetch bookkeeping progression after job has been submitted.
        this.activateBookkeeping().then()

        // Fetch job progression after job has been submitted.
        this.activateJobProgression().then()
      }),
    )

    await this.ratingsVM.activate()

    this.personalProfileVM.activate()
    this.spousalProfileVM.activate()
    this.dependentProfileVM.activate()
    this.businessInfoVM.activate()
    this.taxRefundMethodVM.activate()
    this.txfJobViewModel.activate()
  })

  promptForTimeSlotSelection = task.resolved(async () => {
    if (
      this.job.consultation == null ||
      !this.job.consultation.isPendingBooking
    ) {
      return
    }

    const bookedConsultations =
      await this.consultationStore.fetchBookedConsultations()

    const response =
      await this.consultationPendingBookingModalVM.promptForTimeSlots(
        {
          availability: () => this.job.consultation!.availability,
          bookedConsultations: () => bookedConsultations,
          requestedLength: () => this.job.consultation!.requestedLength,
          clientMember: this.job.championClient!.member,
          currentMember: this.jobWorkspaceMember,
        },
        this.job.jobType,
      )
    if (response == null) {
      return
    }

    try {
      if (response instanceof ConsultationPendingBookingResult.Book) {
        await this.consultationStore.bookConsultation(
          this.job.id!.toString(),
          response.selectedTimeSlot,
        )
        return
      }

      await this.consultationStore.unbookConsultation(this.job.id!.toString())
      this.router.push(link.opportunities())
    } catch (e) {
      this.newAlert().fromError(e).show()
    }
  })

  downloadConsultationCalendar = task.resolved(async () => {
    try {
      if (!this.isConsultationBookedAndActive) {
        return
      }

      const file = await this.consultationStore.downloadConsultationCalendar(
        this.job.id!.toString(),
      )

      this.getAddToCalendarDelegate().addToCalendar(file)
    } catch (e) {
      this.newAlert().fromError(e).show()
    }
  })

  /**
   * Removes the requested champion provider.
   *
   */
  async removeRequestedChampionProviderAsAdmin() {
    await this.jobStore.requestChampionProviderAsAdmin(
      Id.assert(this.job.id),
      null,
    )
  }

  /**
   * Removes the collaborator as Admin.
   *
   * @param job
   * @param collaborator
   * @param reason
   */
  async removeCollaboratorAsAdmin(
    job: Job,
    collaborator: Collaborator,
    reason: string,
  ) {
    await this.jobStore.removeCollaboratorAsAdmin(
      Id.assert(job.id),
      Id.assert(collaborator.member.user.publicId),
      reason,
    )
  }

  /**
   * Adds a champion Provider as Admin.
   *
   * @param job
   * @param provider
   * @param reason
   */
  async addChampionProviderAsAdmin(
    job: Job,
    provider: Collaborator,
    reason: string,
  ) {
    await this.jobStore.addChampionProviderAsAdmin(
      Id.assert(job.id),
      Id.assert(provider.member.user.publicId),
      reason,
    )
  }

  fetchChecklist = task.resolved(async () => {
    await this.infoGatheringStore.getChecklist(this.job.id).catch((error) => {
      this.newAlert().fromError(error).show()
    })
  })

  /**
   * Adds a supporting Provider as Admin.
   *
   * @param job
   * @param provider
   * @param reason
   */
  async addSupportingProviderAsAdmin(
    job: Job,
    provider: Collaborator,
    reason: string,
  ) {
    await this.jobStore.addSupportingProviderAsAdmin(
      Id.assert(job.id),
      Id.assert(provider.member.user.publicId),
      reason,
    )
  }

  /**
   * The view for this view model is no longer relevant.
   */
  deactivate() {
    this.subscription.unsubscribe()
    this.conversationVM.deactivate()
    this.detailsVM.deactivate()
    this.jobTicketsVM.deactivate()
    this.renameVM.close()
    this.forfeitVM.close()
    this.correctionsVM.close()
    this.documentLinkingPickerVM.close()
    this.requestScopeChangesVM.close()
    this.copyVM.close()
    this.ratingsVM.deactivate()
    this.businessInfoVM.deactivate()
    this.dependentProfileVM.deactivate()
    this.personalProfileVM.deactivate()
    this.spousalProfileVM.deactivate()
    this.taxRefundMethodVM.deactivate()
    this.documentsVM.deactivate()
    this.bookkeepingProgressionVM.deactivate()
  }

  /**
   * If the current user is representing a Team on the job,
   * fetch their team member.
   */
  private async fetchTeamMemberForCurrentUser() {
    const collaborator = this.job.collaborators.find(
      (c) => c.member.isCurrentUser,
    )
    if (collaborator && collaborator.team) {
      await this.fetchTeamMember(
        Id.assert(collaborator.team.id),
        Id.assert(collaborator.member.user.publicId),
      )
    }
  }

  /**
   * Ensures the terms of use are accepted for the workspace in which the job resides.
   */
  private async ensureTermsAcceptedForJob() {
    if (this.job.workspace.features.tos.hideOnWortal) {
      return
    }

    const id = this.job.workspace.features.tos.customTermsEnabled
      ? this.job.workspace.id
      : null

    await this.ensureTermsAccepted(id)
  }

  /**
   * Fetches job's billing transactions.
   */
  private async fetchBillingTransactions() {
    return this.billingStore.fetchBillingTransactions([
      ...this.job.stripeCharges,
      ...this.job.stripeRefunds,
    ])
  }

  /**
   * Fetches billing methods for the job.
   */
  private async fetchBillingMethods() {
    if (this.job.ownerTeam) {
      return this.billingStore.fetchBillingMethodsForTeam(this.job.ownerTeam)
    }

    return this.billingStore.fetchBillingMethodsForIndividual(this.job.owner)
  }
}

/**
 * Sidebar tab.
 */
export const enum Tab {
  Details,
  Milestones,
  Documents,
  Collaborators,
  Communication,
}

export interface StatusHistorySummaryType {
  prefix: string | null
  time: string
  suffix: string | null
}
